
import { useContext, useLayoutEffect, useState } from 'react';
import './style/categoryBtn.css';
import { media } from '../../../dataSets/media';
import { AppContext } from '../../../contextApi/ContextApi';

export default function CategoryBtn({ website, logoPath, name, change, categoryNow, inx }) {

  const {fetchImage, primary_color, accent_color} = useContext(AppContext);
  const [imgUrl, setImgUrl] = useState();
  useLayoutEffect(()=>{
      fetchImage(website, logoPath, setImgUrl);
  },[logoPath])

  return (
    <div key={`categoryBtnKey_${inx}`} className={categoryNow?._id === logoPath?._id ? "categoryBtn_selected" : 'categoryBtn'}>
      <h4 className='categoryBtn_header' style={{margin:"0", color:categoryNow?._id===logoPath?._id ? primary_color : accent_color, textShadow:`2px 2px 3px ${categoryNow?._id===logoPath?._id ? accent_color : primary_color}`}}>{name}</h4>
      <img key={`categoryBtnImgKey_${inx}`} className={categoryNow?._id === logoPath?._id ? "categoryBtn_img_selected" : 'categoryBtn_img'} src={imgUrl || media.webingoLogo} alt="category" onClick={()=>{change(name)}}/>
    </div>
  )
}
